import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { scrollToId } from "@/lib/lenis";
import Magnetic from "@/components/Magnetic";

const LINKS = [
    { id: "work", label: "Arbeiten", testid: "nav-work-link" },
    { id: "about", label: "Über mich", testid: "nav-about-link" },
    { id: "services", label: "Leistungen", testid: "nav-services-link" },
    { id: "contact", label: "Kontakt", testid: "nav-contact-link" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const go = (id) => {
        setOpen(false);
        if (location.pathname !== "/") {
            navigate("/");
            setTimeout(() => scrollToId(id), 500);
        } else {
            scrollToId(id);
        }
    };

    return (
        <>
            <header
                data-testid="main-nav"
                className="fixed inset-x-0 top-0 z-[110] mix-blend-difference"
            >
                <div className="mx-auto flex max-w-[1600px] items-center justify-between px-5 py-5 sm:px-10">
                    <Link
                        to="/"
                        data-testid="nav-logo"
                        data-cursor="link"
                        aria-label="BVISION Designer Studio — zur Startseite"
                    >
                        <img src="/media/wordmark.png" alt="BVISION Designer Studio" className="h-6 w-auto sm:h-7" />
                    </Link>
                    <nav className="hidden items-center gap-8 md:flex" aria-label="Hauptnavigation">
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                data-testid={l.testid}
                                data-cursor="link"
                                onClick={() => go(l.id)}
                                className="group relative font-mono text-[11px] uppercase tracking-[0.25em] text-[#F4F4F0]/80 transition-colors duration-300 hover:text-[#F4F4F0]"
                            >
                                {l.label}
                                <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#E63946] transition-[width] duration-300 group-hover:w-full" />
                            </button>
                        ))}
                    </nav>
                    <button
                        data-testid="nav-menu-toggle"
                        data-cursor="link"
                        onClick={() => setOpen(!open)}
                        className="flex flex-col gap-1.5 md:hidden"
                        aria-label="Menü öffnen"
                    >
                        <span className={`h-px w-7 bg-[#F4F4F0] transition-transform duration-300 ${open ? "translate-y-[3.5px] rotate-45" : ""}`} />
                        <span className={`h-px w-7 bg-[#F4F4F0] transition-transform duration-300 ${open ? "-translate-y-[3.5px] -rotate-45" : ""}`} />
                    </button>
                </div>
            </header>

            <AnimatePresence>
                {open && (
                    <motion.div
                        data-testid="mobile-menu"
                        initial={{ clipPath: "inset(0 0 100% 0)" }}
                        animate={{ clipPath: "inset(0 0 0% 0)" }}
                        exit={{ clipPath: "inset(0 0 100% 0)" }}
                        transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
                        className="fixed inset-0 z-[105] flex flex-col justify-center bg-[#132B21] px-8 md:hidden"
                    >
                        {LINKS.map((l, i) => (
                            <div key={l.id} className="overflow-hidden border-b border-white/10">
                                <motion.button
                                    initial={{ y: "110%" }}
                                    animate={{ y: 0 }}
                                    transition={{ duration: 0.6, delay: 0.15 + i * 0.07, ease: [0.16, 1, 0.3, 1] }}
                                    onClick={() => go(l.id)}
                                    className="block w-full py-5 text-left font-display text-4xl font-bold uppercase tracking-tight text-[#F4F4F0]"
                                >
                                    <span className="mr-4 font-mono text-xs text-[#E63946]">0{i + 1}</span>
                                    {l.label}
                                </motion.button>
                            </div>
                        ))}
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}
